import { Guid } from "@/Common/Models/Guid";

class UpdateClickableTextOrderNumberRequest {
    public ItemId: Guid | string;
    public TabOrderIndex: number;
}

export { UpdateClickableTextOrderNumberRequest };
